module.exports = __webpack_public_path__ + "img/waterlilly3.b5497972.jpg";